import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useAuthStore from "../../../store/authStore";
import { login } from "../service/auth_service";
import ForgotPasswordModal from "./ForgotPasswordModal";
import { ExternalFilterModule } from "ag-grid-community";
import useUserContextStore from "../../../store/userContextStore";

const FORCE_ENABLE_MFA = process.env.REACT_APP_FORCE_ENABLE_MFA;

const LoginForm = ({setContext}) => {
  const setUserContext = useUserContextStore((state)=> state.setUserContext)
  const [showModal, setShowModal] = useState(false);
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [fieldType, setFieldType] = useState("password");
  const onToggle = () => {
    setFieldType(fieldType === "password" ? "text" : "password");
  };
  const navigate = useNavigate();
  const setUser = useAuthStore((state) => state.setUser);
  const setToken = useAuthStore((state)=> state.setToken);
  const requireMfa = useAuthStore((state) => state.requireMfa);
  const setLoading = useAuthStore((state) => state.setLoading);
  const setError = useAuthStore((state) => state.setError);
  const setShowMfaImage = useAuthStore((state) => state.setShowMfaImage);
  const error = useAuthStore((state) => state.error);
  const setInputUserName = useAuthStore((state)=> state.setInputUserName);
  const getPostLoginRoute = (roleId, userId)  => ([1,2].includes(Number(roleId)) ? "/AdminContact" :  `/Asset/Overview/${btoa(userId)}`);

  const handleLogin = async () => {
    if(userName.trim().length == 0 && password.trim().length == 0 ){
      setError("Enter Credentials");
      return;
    }
    else if(userName.trim().length == 0){
      setError("User Name is required");
      return;
    }
    else if(password.trim().length == 0){
      setError("Password is required");
      return;
    }

    try {
      setLoading(true);

      const response = await login({
        userName,
        password,
      });

      if(response.data.status === "SUCCESS" || response.data.status === "PASSWORD_TEMPORARY"){
        const nextPageKeyRaw = response.data.nextPageKey ?? response.data.NextPageKey ?? "";
        const nextPageKey = nextPageKeyRaw.toString().toUpperCase();

        setShowMfaImage(response.data.showMFAImage);
        requireMfa(response.data.isMFAEnabled);
        setInputUserName(userName);
        setUser({
          userid: response.data.userId,
          roleid: response.data.roleId,
          categoryid: response.data.categoryId
        })
        setError("");

        if (response.data.status === "PASSWORD_TEMPORARY") {
          window.__USER_PROFILE_CONTEXT__ = {
            userProfileType: "ChangeForgotPassword",
            currentUserId: btoa(response.data.userId),
            userId: btoa(response.data.userId),
            contactId: btoa(response.data.userId),
            userName,
            roleId: response.data.roleId,
            tempPassword: password,
            passwordTemporary: true,
            isTempPasswordActive: true,
            postPasswordNextPageKey: nextPageKey,
          };
          setUserContext(window.__USER_PROFILE_CONTEXT__)
          setContext(window.__USER_PROFILE_CONTEXT__);
          setToken(response.data.token)
          if(nextPageKey === "CHALLENGEPHRASE"){
            navigate(`/UserProfile/${btoa(response.data.userId)}/password`);
            return;
          }
          navigate(`/`);
          return;
        }

        if (nextPageKey === "DISCLAIMER") {
          navigate("/disclaimer", {
            state: { userId: response.data.userId, userName, password },
          });
          return;
        }
        if ((FORCE_ENABLE_MFA=="true" && response.data.isMFAEnabled) || (nextPageKey==="TOTP" && response.data.isMFAEnabled)) {
          navigate("/mfa-verification");
        } else if((FORCE_ENABLE_MFA=="true" && !response.data.isMFAEnabled) || (nextPageKey==="TOTP" && !response.data.isMFAEnabled)){
          navigate("/mfa-setup");
        } else{
          setToken(response.data.token);
          setError("");
          navigate(getPostLoginRoute(response.data.roleId, response.data.userId));
          return;
        }
      }
      else{
        setError(response.data.message);
      }

    } catch (err) {
      setError("Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
  const style = document.createElement("style");
  style.textContent = `
    .login_form .password-field-wrap {
      position: relative;
      margin-bottom: 10px;
    }
    .login_form .password-field-wrap .form-control {
      padding-right: 34px;
      margin-bottom: 0;
    }
    .login_form .user-profile-eye-btn {
      position: absolute;
      top: 50%;
      right: 8px;
      transform: translateY(-50%);
      background: none;
      border: none;
      padding: 0;
      line-height: 1;
      color: #6c757d;
      cursor: pointer;
    }
  `;
  document.head.appendChild(style);
  return () => style.remove();
}, []);

  return (
    <>
    <form id="loginForm" className="login_form loginForm" 
      onKeyUp={(e)=>{if (e.key === "Enter") {
        handleLogin();
      }}}>

      {/* {error.length > 0 &&  */}
      <div id="AfterErrorLogin">
        <p id='paraAfterErrorLogin'>{error}</p>
      </div>
      {/* } */}

      <input
        type="text"
        name="UserName"
        className="form-control"
        id="txtUserName"
        autoComplete="off"
        placeholder="User Name"
        value={userName}
        onChange={(e)=>{
          setUserName(e.target.value);
          setError("");
        }}
      />

      <div className="password-field-wrap">
  <input
    type={fieldType}
    name="Password"
    id="txtPassword"
    className="form-control"
    autoComplete="off"
    placeholder="Password"
    value={password}
    onChange={(e)=>{
      setPassword(e.target.value);
      setError("");
    }}
  />
  <button type="button" className="user-profile-eye-btn" onClick={onToggle}>
    <span className="glyphicon glyphicon-eye-open" />
  </button>
</div>

      <div
        className="row"
        style={{ margin: "0px 0px 10px 0px", gap: "4px", display: "flex" }}
      >
        <button
          id="submitLogin"
          type="button"
          className="btn btn1 col-md-3"
          onClick={()=>handleLogin()}
        >
          Go
        </button>

        <button
          type="button"
          className="btn btn2 col-md-9"
          onClick={()=>setShowModal(true)}
        >
          Forgot User Name / Password?
        </button>
      </div>

      <div className="clearfix"></div>
    </form>
    <ForgotPasswordModal
      show={showModal}
      onClose={() => setShowModal(false)}
    />
    </>
  );
};

export default LoginForm;
